const environment = {
  baseUrl: 'https://admin.hydropoweroilfield.abudhabi', 
}
export { environment };